import React from 'react'
import { components } from 'cng-web-lib'

import TmpCodeMasterApiUrls from 'src/apiUrls/TmpCodeMasterApiUrls'
import FormProperties from './FormProperties'
import pathMap from 'src/paths/PathMap_TmpAdmin'

const {
  form: {
    CngAddForm
  }
} = components

function AddPage({ history, showNotification }) {
  return (

    <CngAddForm
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      shouldDisableEnterToSubmit
      showNotification={showNotification}
      history={history}
      bodySection={
        < FormProperties.Fields
          disabled={false}
          showNotification={showNotification}
          mode={"add"}
        />
      }
      formikProps={FormProperties.formikProps}
      toClientDataFormat={FormProperties.toClientDataFormat}
      toServerDataFormat={FormProperties.toServerDataFormat}

      create={{
        url: TmpCodeMasterApiUrls.CREATE,
        successRedirect: pathMap.CODE_MASTER_LIST_VIEW
      }}
    />
  )

}


export default AddPage
